import { useSelectFolderQuery } from 'generated/graphql';
import React from 'react';

export interface IData {
  id: string;
  name: string;
  displayName: string;
}

export function useQuery(projectId: string) {
  const tuple = useSelectFolderQuery({
    variables: {
      projectId
    },
    skip: projectId === ''
  });

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.project?.folders.map((node) => ({
        id: node.id,
        name: node.id,
        displayName: node.name
      })) ?? [];

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
